import BaseCollection from "lib/collection";
import BrandModel from "models/brand";

export default BaseCollection.extend({
    url: "/brands",
    forceModuleName: "all",
    model: BrandModel,
});
